import React from 'react'

const Info = function info ({text}){
    return (
        <main>
            <div className="back flex w90">
                <a href={https} className="flex">
                <img src={https+"img/back.svg"} alt="⬅"/>
                <span>Atrás</span>
                </a>
            </div>

            <section className="colflex terms w90">
                <h2>{text.title}</h2>
                <p>{text.text}</p>
            </section>
        </main>
)
}

export default Info
